module.exports = __webpack_public_path__ + "static/img/s1.d13aa47.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/s1.png
// module id = 7OiM
// module chunks = 0